import { User } from "./types";
import { UserRoleBadgeEnum } from "./Types/UserRoleBadgeEnum";

export function getUserName(screenName?: string, firstLetterOnly = false) {
    if (!screenName || screenName === "") {
        return firstLetterOnly ? "G" : "Gast";
    }

    return firstLetterOnly
        ? screenName[0].toUpperCase()
        : capitalizeAllWords(screenName);
}

export function capitalizeAllWords(value: string) {
    const words = value.split(" ");
    return words
        .map((word) => {
            if (word.length > 0)
                return word[0].toUpperCase() + word.substring(1);
        })
        .join(" ");
}

export function isCustomer(user: User) {
    return ![UserRoleBadgeEnum.SUPPORT, UserRoleBadgeEnum.MODERATOR].includes(
        user.role as UserRoleBadgeEnum,
    );
}
